// extracted by mini-css-extract-plugin
module.exports = {"demographics-overview__no-data":"ReportingDemographics_demographics-overview__no-data__2TtXy"};